module.exports = __webpack_public_path__ + "img/thumbnail_AfricanLeopard_m_erythristic.193610f1.png";